import { useEffect, useState } from "react";
import api from "../../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import DeleteButton from "../../../components/DeleteButton";

export default function PaymentMethodPage() {
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleDeletePaymentMethod = async (id) => {
    try {
      await api.delete(`/payment-methods/${id}`);
      navigate("/configuracoes");
    } catch (error) {
      console.error("erro ao excluir método de pagamento: ", error);
      alert(
        "Erro ao excluir método de pagamento. Verifique se algum pedido utiliza esse método"
      );
    }
  };

  useEffect(() => {
    async function fetchPaymentMethod() {
      try {
        const response = await api.get(`/payment-methods/${id}`);
        setPaymentMethod(response.data);
        console.log("payment methods: ", response.data);
      } catch (error) {
        console.error("Erro ao buscar métodos de pagamento:", error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchPaymentMethod();
  }, [id]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen text-lg font-semibold">
        Carregando...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-lg p-6">
        <div className="flex  justify-between">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            Método de Pagamento
          </h1>
          <DeleteButton onConfirm={() => handleDeletePaymentMethod(id)} />
        </div>
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            {paymentMethod.name}
          </h2>
          <p className="text-gray-600">
            <strong>Criado em:</strong>{" "}
            {new Date(paymentMethod.createdAt).toLocaleDateString()}
          </p>
          <p className="text-gray-600">
            <strong>Última atualização:</strong>{" "}
            {new Date(paymentMethod.updatedAt).toLocaleDateString()}
          </p>
        </div>
        <h3 className="text-lg font-semibold text-gray-700 mb-4">
          Número de Parcelas: {paymentMethod.paymentInstallment.length}
        </h3>
        <ul className="space-y-4">
          {paymentMethod.paymentInstallment.map((installment, index) => (
            <li
              key={installment.id}
              className="p-4 bg-gray-50 border border-gray-200 rounded-lg"
            >
              <p className="mb-4 font-semibold text-lg">Parcela {index + 1}</p>
              {!installment.matchLeadTime && (
                <p className="text-gray-700">
                  <strong>Dias para pagamento: </strong>
                  {installment.paymentInDays}
                </p>
              )}
              <p className="text-gray-700">
                <strong>Porcentagem:</strong> {installment.percentage * 100}%
              </p>
              <p className="text-gray-700">
                <strong>Pagamento no Lead Time:</strong>{" "}
                {installment.matchLeadTime ? "Sim" : "Não"}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
